import React from 'react'
import { type JapaneseAirport } from './mapConstants'
import { useSearchStore } from '../../../store/jpeTopPageStore'

interface AirportMarkerProps {
  airport: JapaneseAirport
}

export const AirportMarker: React.FC<AirportMarkerProps> = ({ airport }) => {
  const [isHovered, setIsHovered] = React.useState(false)
  const { isDesktop } = useSearchStore()

  const handleTap = () => {
    setIsHovered(true)
    if (!isDesktop) {
      setTimeout(() => {
        setIsHovered(false)
      }, 1500)
    }
  }

  return (
    <div
      style={{
        transform: 'translate(-50%, -50%)',
        zIndex: isHovered ? 1001 : 1,
      }}
      className="absolute"
      title={`${airport.nameEn} (${airport.code})`}
      onClick={() => {
        handleTap()
      }}
      onMouseLeave={() => {
        setIsHovered(false)
      }}
    >
      <svg width="18" height="18" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_29400_40042)">
          <rect width="15" height="15" rx="4" fill="#333333" />
          <path
            d="M13.75 10V8.75L8.4375 5.625V2.1875C8.4375 1.66875 8.01875 1.25 7.5 1.25C6.98125 1.25 6.5625 1.66875 6.5625 2.1875V5.625L1.25 8.75V10L6.5625 8.4375V11.875L5 12.8125V13.75L7.5 13.125L10 13.75V12.8125L8.4375 11.875V8.4375L13.75 10Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_29400_40042">
            <rect width="15" height="15" rx="4" fill="white" />
          </clipPath>
        </defs>
      </svg>
      {isHovered && (
        <div
          className="absolute bg-white rounded-lg shadow-lg p-2 whitespace-nowrap"
          style={{
            bottom: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            marginBottom: '16px',
            zIndex: 1005,
          }}
        >
          <div className="text-sm font-bold text-gray-800">{`${airport.nameEn} (${airport.code})`}</div>
          <div
            className="absolute"
            style={{
              bottom: '-8px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: 0,
              height: 0,
              borderLeft: '8px solid transparent',
              borderRight: '8px solid transparent',
              borderTop: '8px solid white',
            }}
          />
        </div>
      )}
    </div>
  )
}
